import Firebase from 'firebase/app';
import 'firebase/auth';
import '@firebase/firestore';
import 'firebase/storage';

export const API_KEY = 'AIzaSyDj6hgq_dIY7-wxbhAEt88c_xtTiwowISs';
export const AUTH_DOMAIN = 'mca-dev-3954c.firebaseapp.com';
export const DATABASE_URL = 'https://mca-dev-3954c.firebaseio.com';
export const PROJECT_ID = 'mca-dev-3954c';
export const STORAGE_BUCKET = 'mca-dev-3954c.appspot.com';
export const MESSAGING_SENDER_ID = '1082834851928';
export const APP_ID = '1:1082834851928:web:2fcc2821c93fe4fcc8d22d';

export interface FirebaseConfig {
  apiKey: string;
  authDomain?: string;
  databaseUrl?: string;
  projectId?: string;
  storageBucket?: string;
  messagingSenderId?: string;
  appId?: string;
  measurementId?: string;
}

const mcaFirebaseConfig: FirebaseConfig = {
  apiKey: API_KEY,
  authDomain: AUTH_DOMAIN,
  databaseUrl: DATABASE_URL,
  projectId: PROJECT_ID,
  storageBucket: STORAGE_BUCKET,
  messagingSenderId: MESSAGING_SENDER_ID,
  appId: APP_ID,
};

const mcaProdConfig: FirebaseConfig = {
  apiKey: 'AIzaSyDBcD2pMdv07ahyM1zgQwsqqPh1YB1NEqU',
  authDomain: 'mycookaround-282610.firebaseapp.com',
  databaseUrl: 'https://mycookaround-282610.firebaseio.com',
  projectId: 'mycookaround-282610',
  storageBucket: 'mycookaround-282610.appspot.com',
  messagingSenderId: '550494388110',
  appId: '1:550494388110:web:882d7ba17ef6abb73c2edf',
  measurementId: 'G-W6DEN4SKER',
};

export const MyCookAroundFirebase: Firebase.app.App = Firebase.initializeApp(
  mcaProdConfig
  // mcaFirebaseConfig
);

export const firestore = MyCookAroundFirebase.firestore();
